/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { ButtonBase } from '@mui/material';

const CustomButton = ({ icon, children, ...rest }) => {

  return (
    <ButtonBase
        {...rest}
        css={css`background-color: #2A3042; padding: 0 10px; border-radius: 0.6rem; height: 38px;`}
    >
     {icon}{children}
    </ButtonBase>
  );
};

export default CustomButton;
